module.exports = __webpack_public_path__ + "media/images/responsive/costumes/category_icons/dress/aline-4ef182efbb2c2a9f6eb123ad61a0b85a.jpg";